var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"88px","line-height":"88px","font-size":"14px","color":"rgb(201, 204, 216)","border-radius":"4px","border":"1px dashed rgb(212, 215, 224)","text-align":"center","background":"rgb(255, 255, 255)"}},[_c('i',{staticClass:"el-icon-edit"}),_vm._v(" 点击添加手写签名 ")])
}]

export { render, staticRenderFns }